// src/Pages/AccountManagement/pages/components/clientpopups.jsx
import React, { Suspense } from "react";
import { Fade, CircularProgress, Box } from "@mui/material";

const AddEditClientDialog    = React.lazy(() => import("./clienteditdialog"));
const ClientNotesDialog      = React.lazy(() => import("./clientnotesdialog"));
const ClientCampaignsDialog  = React.lazy(() => import("./clientcampaignsdialog"));
const ShareClientDialog      = React.lazy(() => import("./ShareClientDialog"));

const DialogSkeleton = () => (
  <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: 400 }}>
    <CircularProgress size={48} />
  </Box>
);

export default function ClientPopups(props) {
  const { popup } = props;
  if (!popup?.type) return null;

  const renderDialog = () => {
    switch (popup.type) {
      case "add":
      case "edit":
        return <AddEditClientDialog {...props} />;

      case "notes":
        return (
          <ClientNotesDialog
            open={true}
            onClose={() => {
              // Notify parent so it can invalidate todo stats cache
              props.onPopupClose?.("notes", popup.client?.id ?? popup.client?.client_id);
              props.setPopup({ type: null });
            }}
            entity={popup.client}
            entityType="client"
            defaultTab={popup.defaultTab}   // ← "tasks" when clicking a task badge
            onRefresh={props.refreshClients}
          />
        );

      case "campaigns":
        return <ClientCampaignsDialog {...props} />;

      case "share":
        return (
          <ShareClientDialog
            open={true}
            onClose={() => props.setPopup({ type: null })}
            clientData={popup.client}
            onSuccess={props.refreshClients}
          />
        );

      default:
        return null;
    }
  };

  return (
    <Fade in={!!popup?.type} timeout={300}>
      <div>
        <Suspense fallback={<DialogSkeleton />}>
          {renderDialog()}
        </Suspense>
      </div>
    </Fade>
  );
}